import { media } from 'styled-bootstrap-grid';
import styled, { css } from 'styled-components';

export const CategoryPickerWrapper = styled.div<{ isInsideModal: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  select {
    min-height: 56px;
    padding-left: 10px;
    display: flex;
    align-items: center;
  }

  ${media.md`
    width: 190px;
  `}

  ${({ isInsideModal }) =>
    isInsideModal &&
    css`
      width: 100%;
    `}
`;

export const DesktopLabel = styled.div`
  font-size: 15px;
  margin-bottom: 3px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  text-align: left;

  @media screen and (max-width: 767px) {
    margin-bottom: 8px;
  }
`;
